import { RequestStatus } from 'constants/RequestStatus';

import { PlanPredictCurvesResponsePayload, PlanPredictCurvesWithIdRequestPayload } from 'api/curves';

import { CurveItem } from 'app/components/containers/widgets/ProductionCurves/types';
import { CurveType, EmissionCurvesType, P_Curve } from 'types/Curve';
import { PlanModelType } from 'types/PlanPredictModel';

export type PLAN_CURVE_DATA_KEY = `${CurveType}_${PlanModelType}` | `${CurveType}_${PlanModelType}_${P_Curve}`;
export type PLAN_CURVE_CHART_KEY = `${PLAN_CURVE_DATA_KEY}_${number}` | PLAN_CURVE_DATA_KEY | string;
export type PLAN_CURVE_EMISSION_DATA_KEY =
  | `${EmissionCurvesType}_${PlanModelType}`
  | `${EmissionCurvesType}_${PlanModelType}_${P_Curve}`;
export type EMISSION_CHART_KEY = `${PLAN_CURVE_EMISSION_DATA_KEY}_${number}` | PLAN_CURVE_EMISSION_DATA_KEY | string;

export type PlanProdDataItem = CurveItem<PLAN_CURVE_DATA_KEY>;
export type PlanProdChartItem = CurveItem<PLAN_CURVE_CHART_KEY>;
export type PlanEmissionChartItem = CurveItem<EMISSION_CHART_KEY>;

export enum ECurvesType {
  PROD_CURVES = 'prodCurves',
  EMISSION_CURVES = 'emissionCurves',
}
export interface PlanProdCurvesWellState {
  status: RequestStatus;
  error: string | null;
  dataKey: string | null;
  [ECurvesType.PROD_CURVES]: {
    data: PlanProdDataItem[] | null;
    rawData: PlanPredictCurvesResponsePayload[] | null;
  };
  [ECurvesType.EMISSION_CURVES]: {
    data: Record<string, number>[] | null;
    rawData: PlanPredictCurvesResponsePayload<EmissionCurvesType>[] | null;
  };
}

export interface PlanProdCurvesLoadedType {
  wellsPayload: PlanPredictCurvesWithIdRequestPayload[];
  chartData: { [key: string]: PlanProdDataItem[] };
  rawData: PlanPredictCurvesResponsePayload[];
  emmisionChartData: Record<string, number>[];
}

export interface PlanProdCurvesWidgetState {
  [key: number]: PlanProdCurvesWellState;
}
